import { getPreference } from '@openclassrooms/utils/config';

export const FACEBOOK_COLOR = '#1877F2';

export function getFacebookConfig() {
  return {
    color: FACEBOOK_COLOR,
    clientId: getPreference('facebook')?.appId,
  };
}
